import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { getThemeName, getThemeSupportEmail, isInternationalTheme } from "config/ConfigUtils";

import "./HelpSettings.css";

const CALENDLY_URL = "https://calendly.com/routebot/intro";

const HelpSettings = () => {
  const { t } = useTranslation();
  const themeName = getThemeName();
  const supportEmail = getThemeSupportEmail();
  const [copied, setCopied] = useState(false);

  const handleCopyEmail = async () => {
    try {
      await navigator.clipboard.writeText(supportEmail);
      setCopied(true);
      window.toast.success(t("helpSettings.copied"));
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      const textArea = document.createElement("textarea");
      textArea.value = supportEmail;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      setCopied(true);
      window.toast.success(t("helpSettings.copied"));
      setTimeout(() => setCopied(false), 1500);
    }
  };

  return (
    <div className="help-settings">
      {/* Hero Section */}
      <div className="help-hero">
        <h1 className="help-hero-title">{t("helpSettings.title")}</h1>
        <p className="help-hero-subtitle">{t("helpSettings.subtitle")}</p>

        <div className="help-hero-email-block">
          <div className="help-email-field">
            <span className="help-email-text">{supportEmail}</span>
            <button
              className="help-email-copy-btn"
              onClick={handleCopyEmail}
              title={copied ? t("helpSettings.copied") : t("helpSettings.clickToCopy")}
            >
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                {copied ? (
                  <path
                    d="M20 6L9 17L4 12"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                ) : (
                  <>
                    <rect x="9" y="9" width="13" height="13" rx="2" stroke="currentColor" strokeWidth="2" />
                    <path
                      d="M5 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2H13C14.1046 2 15 2.89543 15 4V5"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                  </>
                )}
              </svg>
            </button>
          </div>
          <span className="help-hero-reply-time">{t("helpSettings.replyTime")}</span>
        </div>

        {isInternationalTheme() && (
          <div className="help-hero-demo-link">
            <span>{t("helpSettings.preferCall")}</span>
            <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" className="help-book-call-link">
              {t("helpSettings.bookCall")}
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7 17L17 7M17 7H7M17 7V17"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
          </div>
        )}
      </div>

      {/* Quick Tips Section */}
      <div className="help-section">
        <div className="help-card help-card-tips">
          <div className="help-card-header">
            <div className="help-card-icon help-card-icon-tips">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <h2 className="help-card-title">{t("helpSettings.quickTipsTitle")}</h2>
          </div>
          <div className="help-card-content">
            {/* <p className="help-tip-description">{t("helpSettings.quickTipsDescription")}</p> */}

            <div className="help-tooltip-demo">
              <div className="help-tooltip-demo-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                  <path d="M12 16V12M12 8H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </div>
              <div className="help-tooltip-demo-content">
                <span className="help-tooltip-demo-label">{t("helpSettings.tooltipExample")}</span>
                <p className="help-tooltip-demo-text">{t("helpSettings.tooltipExampleText")}</p>
              </div>
            </div>

            <ul className="help-tips-list">
              <li>
                <span className="help-tip-icon">💡</span>
                <span>{t("helpSettings.tip1")}</span>
              </li>
              <li>
                <span className="help-tip-icon">🔍</span>
                <span>{t("helpSettings.tip2")}</span>
              </li>
              {/* <li>
                <span className="help-tip-icon">📖</span>
                <span>{t("helpSettings.tip3")}</span>
              </li> */}
            </ul>
          </div>
        </div>
      </div>

      {/* Footer */}
      {/* <div className="help-footer">
        <p>{t("helpSettings.footer", { brand: themeName })}</p>
      </div> */}
    </div>
  );
};

export default HelpSettings;
